export const dashInvoices = {
  invoices: {
    title: "فواتير بانتظار الإرسال",
    subtitle: "ستظهر هنا الطلبات المعلّقة لإصدار الفاتورة.",
    loading: "جارٍ التحميل…",
    empty: "لا توجد فواتير بانتظار الإرسال.",
    guestFallback: "نزيل",
    manualBadge: "يدوي",
    manualBadgeTitle: "لا تُنشأ تلقائيًا: تصدرها أنت يدويًا",
    manualCheckoutTitle: "لا تُنشأ تلقائيًا: أصدرها أنت يدويًا",
    linkSentTitle: "تم إرسال الرابط إلى النزيل",
    linkPendingTitle: "سيُرسل الرابط يوم تسجيل المغادرة",
    manualIssue: "إصدار يدوي",
    sendLinkTitle: "أرسل إلى النزيل الرابط لإكمال بيانات الفاتورة",
    resend: "إعادة الإرسال",
    sendLink: "إرسال الرابط",
    closeRequestTitle: "إغلاق هذا الطلب (تصدرها أنت يدويًا)",
    close: "إغلاق",
    cancelAutoTitle: "إلغاء الإرسال التلقائي لإرسالها يدويًا بوسيلة أخرى",
    cancel: "إلغاء",
    viewAll: "عرض جميع الفواتير",
    confirmCancel: {
      title: "إلغاء الإرسال التلقائي؟",
      html: "لن يُرسل رابط الفاتورة إلى النزيل.<br>يمكنك إرسالها يدويًا بوسيلة أخرى.",
      confirm: "نعم، ألغِ",
      cancel: "لا",
    },
    confirmSend: {
      title: "إرسال رابط الفاتورة؟",
      html: "سيُرسل إلى النزيل عبر واتساب الرابط لإكمال بياناته الضريبية.<br>الفاتورة تصدرها أنت يدويًا.",
      confirm: "نعم، أرسل",
      cancel: "لا",
    },
    cancelError: {
      title: "تعذّر الإلغاء",
    },
    closeError: {
      title: "تعذّر الإغلاق",
    },
    sendError: {
      title: "تعذّر الإرسال",
    },
    sendSuccess: {
      title: "تم إرسال الرابط",
      text: "استلم النزيل رابط الفاتورة.",
    },
    retry: "حاول مرة أخرى.",
  },
  balances: {
    title: "الأرصدة المستحقة",
    subtitle: "حجوزات عليها مبلغ مستحق التحصيل.",
    total: "الإجمالي",
    paid: "تمت معالجة الدفع",
    loading: "جارٍ التحميل…",
    empty: "لا توجد أرصدة مستحقة.",
    emptySub: "عندما يكون على الحجز مبلغ مستحق، سيظهر هنا.",
    viewAll: "عرض جميع الأرصدة",
  },
  balancesDrawer: {
    title: "الأرصدة المستحقة",
    close: "إغلاق",
    from: "من",
    to: "إلى",
    sort: "ترتيب",
    sortArrival: "تاريخ الوصول",
    sortProximity: "قرب موعد الوصول",
    searchPlaceholder: "ابحث عن مكان الإقامة…",
    allAccommodations: "جميع أماكن الإقامة",
    noResults: "لا توجد نتائج",
    clear: "مسح",
    totalPending: "إجمالي المستحق",
    ofTotal: "من {amount} {currency}",
    loading: "جارٍ التحميل…",
    empty: "لا توجد حجوزات عليها رصيد مستحق.",
    end: "لا مزيد.",
    tags: {
      ended: "انتهت الإقامة",
      now: "نزيل حالي",
      today: "يصل اليوم",
      tomorrow: "يصل غدًا",
      dayAfter: "يصل بعد يومين",
    },
  },
};
